module.exports = __webpack_public_path__ + "img/headbg.89d75ce8.svg";